import { dailyReportActionTypes } from '@/components/dailyReport/Constants';

import type { DailyReportActions, DailyReportState } from '@/components/dailyReport/types';

const initialState: DailyReportState = {
	dailyReport: null,
};

export default function dailyReportReducer(
	state = initialState,
	action: DailyReportActions,
): DailyReportState {
	switch (action.type) {
		case dailyReportActionTypes.GET_DAILY_REPORT_SUCCESS:
			return {
				...state,
				dailyReport: action.payload.data,
			};

		default:
			return state;
	}
}
